module.exports = __webpack_public_path__ + "static/media/account_circle.fa86e025.svg";